import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../lib/router/withRouter';
import { message } from 'antd';
import ProductPropertyRequestListWrap from '../../views/product/list/property/request/ProductPropertyRequestListWrap';
import { appActions } from '../../store/modules/app';
import { productActions } from '../../store/modules/product';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import {
  PRODUCT_LIST_FILTER_OPTION_MODEL,
  PRODUCT_PROPERTY_REQUEST_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/product/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class ProductPropertyRequestListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { location } = this.props;

    /**
     *  페이지에 처음 접근하는 것이 아닐 경우, 이전 검색조건으로 검색한다.
     */
    if (location.state) {
      this.getList({
        filterOption: location.state.filterOption,
        pagination: location.state.pagination,
        sortOption: location.state.sortOption,
      });
    } else {
      this.getList({
        filterOption: PRODUCT_LIST_FILTER_OPTION_MODEL,
        pagination: LIST_PAGINATION_MODEL,
        sortOption: PRODUCT_PROPERTY_REQUEST_LIST_SORT_OPTION_MODEL,
      });
    }
  };

  getList = (data) => {
    const { getProductPropertyRequestList, productList, history } = this.props;
    const { filterOption, sortOption, pagination } = productList;

    /**
     *  서버로 요청
     */
    getProductPropertyRequestList({
      filterOption,
      sortOption,
      pagination,
      ...data,
    });

    /**
     *  history 에 검색조건을 저장한다
     */
    history.replace({
      ...history.location,
      state: {
        filterOption,
        sortOption,
        pagination,
        ...data,
      },
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getProductPropertyRequestExcelDownload, pageName, productList, adminInfo } = this.props;

    if (!productList || !productList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getProductPropertyRequestExcelDownload({
      email: adminInfo.email,
      filterOption: productList.filterOption,
      sortOption: productList.sortOption,
      pageName,
    });
  };

  render() {
    const { categorySelectList, productList, getProductSubCategoryList } = this.props;

    return (
      <ProductPropertyRequestListWrap
        categorySelectList={categorySelectList}
        productList={productList}
        getProductSubCategoryList={getProductSubCategoryList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    productList: state.product.productList,
    categorySelectList: state.product.categorySelectList,
  };
};

const mapDispatchToProps = {
  setData: productActions.setData,
  getProductPropertyRequestList: productActions.getProductPropertyRequestList,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
  getProductPropertyRequestExcelDownload: productActions.getProductPropertyRequestExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductPropertyRequestListContainer));
